import { useAtomValue } from 'jotai';
import { useEffect, useRef } from 'react';

import { isScreenSharingAtom, localScreenShareContextAtom, remoteScreenShareParticipantAtom } from '../../video-sdk';
import { useLocalScreenShareComponent } from '../../video-sdk/actions/useComponentActions';
import { ScreenShareVideoLayout } from './ScreenShareVideoLayout';

export function LocalScreenShare() {
  const screenShareRef = useRef<HTMLVideoElement | HTMLCanvasElement>(null);
  const { delegator } = useAtomValue(localScreenShareContextAtom);
  const LocalScreenShareComponent = useLocalScreenShareComponent();
  const localScreenIsShared = useAtomValue(isScreenSharingAtom);
  const remoteScreenShareParticipant = useAtomValue(remoteScreenShareParticipantAtom);

  useEffect(
    function handleScreenShareAttachment() {
      const element = screenShareRef.current;
      if (!delegator || !element) return;

      // Attach delegator (handles both video and audio tracks)
      delegator.attach(element);

      return () => {
        delegator.detach(element);
      };
    },
    [screenShareRef, delegator],
  );

  return (
    <ScreenShareVideoLayout
      className={{
        hidden: !localScreenIsShared && Boolean(remoteScreenShareParticipant),
      }}
    >
      <LocalScreenShareComponent videoRef={screenShareRef} />
    </ScreenShareVideoLayout>
  );
}
